module.exports = __webpack_public_path__ + "fonts/montserrat-v12-latin-700.957e93fb.woff";